import { ReactComponent as SendIcon } from "assets/icons/gift-card/send.svg";
import { ReactComponent as Wallet3Icon } from "assets/icons/wallet-3.svg";
import { ReactComponent as Wallet4Icon } from "assets/icons/wallet-4.svg";
import { varIs } from "common/var";
import { Col, Row } from "components/common";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { callGetApiWithAuth } from "utils/api";
import { asUsdPrice } from "utils/text";
import { Wrapper } from "./BalanceSubPage.styled";

export default function BalanceSubPage(props) {
  const myUser = useSelector((state) => state.auth.user);
  const [statData, setStatData] = useState({
    bonus_amount: 0,
  });

  const onGetCurrentData = ({ data }) => {
    setStatData({
      ...statData,
      ...data,
    });
  };

  useEffect(() => {
    callGetApiWithAuth(
      `my_account/loyalty_wallet/current_level`,
      onGetCurrentData
    );
  }, []);

  return (
    <Wrapper>
      <Row gutter={[20, 20]}>
        <Col xs={24} lg={12} xl={8} xxl={8}>
          <div className="balance-stats">
            <div className="stats-icon">
              <div className="stats-value">
                {asUsdPrice(myUser.loyalty_wallet.amount)}
              </div>
              <div className="stats-title">Current Balance</div>
            </div>
            <Wallet4Icon />
          </div>
        </Col>
        <Col xs={24} lg={12} xl={8} xxl={8}>
          <div className="balance-stats">
            <div className="stats-icon">
              <div className="stats-value">
                {asUsdPrice(myUser.loyalty_wallet.consumed_amount)}
              </div>
              <div className="stats-title">Total Dollars Redeemed</div>
            </div>
            <Wallet3Icon />
          </div>
        </Col>
        {/* <Col xs={24} lg={12} xl={8} xxl={8}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div className="send-gift-btn">
              <button
                onClick={() => {
                  if (
                    myUser &&
                    !varIs("user.status", myUser.status, "hold_temp")
                  ) {
                    props.setModalMode("send");
                  }
                }}
              >
                <SendIcon />
                Send Loyalty Balance
              </button>
            </div>
          </div>
        </Col> */}
      </Row>
    </Wrapper>
  );
}
